import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "absolute left-5 top-5 flex flex-col items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiNode = _resolveComponent("UiNode")!

  return (_openBlock(), _createBlock(_component_UiNode, {
    nodeId: $props.node.id,
    showActions: "",
    noEdition: "",
    onRemoveNode: $setup.removeNode,
    showHandleSource: false,
    hideNodeId: "",
    bgColor: "bg-gray-50",
    borderColor: "border-gray-300",
    roundedStyle: "rounded-2xl",
    padding: "p-0 pt-2 pr-2",
    nodeWidth: "w-24",
    nodeHeight: "h-20"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["PhoneMissedCallIcon"], { class: "mb-1 h-10 w-10 text-gray-600" })
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["nodeId"]))
}